/* global axios */
import ApiClient from '../ApiClient';

class DndAPI extends ApiClient {
  constructor() {
    super('contacts/dnd', { accountScoped: true });
  }

  index(params) {
    return axios.get(this.url, { params });
  }

  enable(contactIds, reason) {
    return axios.post(`${this.url}/enable`, {
      contact_ids: contactIds,
      reason,
    });
  }

  disable(contactIds) {
    return axios.post(`${this.url}/disable`, {
      contact_ids: contactIds,
    });
  }

  check(contactIds) {
    return axios.get(`${this.url}/check`, {
      params: { contact_ids: contactIds },
    });
  }
}

export default new DndAPI();
